/**
 * Vertical density. `regular` (default) is 48px tall and matches the side
 * panel chrome in the design; `compact` (40px) is for nested headers
 * inside an already-elevated container; `comfortable` (56px) is for the
 * top-level page header pattern.
 */
export const PANEL_HEADER_DENSITY_COMPACT = 'compact';
export const PANEL_HEADER_DENSITY_REGULAR = 'regular';
export const PANEL_HEADER_DENSITY_COMFORTABLE = 'comfortable';

export type PanelHeaderDensity =
  | typeof PANEL_HEADER_DENSITY_COMPACT
  | typeof PANEL_HEADER_DENSITY_REGULAR
  | typeof PANEL_HEADER_DENSITY_COMFORTABLE;

export const PANEL_HEADER_DENSITY_TOKENS: Record<
  PanelHeaderDensity,
  {
    height: string;
    padX: string;
    titleFontSize: string;
    subtitleFontSize: string;
  }
> = {
  [PANEL_HEADER_DENSITY_COMPACT]: {
    height: '40px',
    padX: '12px',
    titleFontSize: '13px',
    subtitleFontSize: '11.5px',
  },
  [PANEL_HEADER_DENSITY_REGULAR]: {
    height: '48px',
    padX: '14px',
    titleFontSize: '14px',
    subtitleFontSize: '12px',
  },
  [PANEL_HEADER_DENSITY_COMFORTABLE]: {
    height: '56px',
    padX: '16px',
    titleFontSize: '15.5px',
    subtitleFontSize: '12.5px',
  },
};
